import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';


@Component({
  selector: 'app-dropdown-popup',
  imports: [MatFormFieldModule, CommonModule, MatSelectModule, MatInputModule, FormsModule, MatDialogModule],
  templateUrl: './dropdown-popup.component.html',
  styleUrl: './dropdown-popup.component.scss'
})
export class DropdownPopupComponent {
  selectedMarket: string[] = ['All'];
  constructor(public dialogRef: MatDialogRef<DropdownPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {

  }
  toggleAllMarketSelection() {
    this.selectedMarket =
      this.selectedMarket.includes('All') || this.selectedMarket.length == 0
        ? ['All']
        : [];
  }

  tosslePerOneMarket() {
    if (this.selectedMarket.includes('All')) {
      this.selectedMarket = this.selectedMarket.filter(
        (engine) => engine !== 'All'
      );
    }
    if (
      this.selectedMarket.length === this.data.length ||
      this.selectedMarket.length == 0
    ) {
      this.selectedMarket = ['All'];
    }
  }
}
